<template>
  <v-row>
    <v-col cols="12">
      <v-file-input
        :label="label"
        filled
        :multiple="!singleFile"
        v-model="files"
        :disabled="singleFile && (uploads.length > 0)"
      ></v-file-input>
    </v-col>
    <v-col cols="12" :sm="smIndex" v-for="item of uploads" :key="item._id">
      <v-card >
        <v-card-text>
          <div style="width: 200px; height:200px; text-align:center;display:flex;">
            <span style="margin: auto;" v-if="!item.entity">{{ item.fileName }}</span>
            <v-dialog
              v-else-if="item.entity.isImage"
              v-model="item.imageForm"  
              max-width="800"
              @click:outside="closeImageForm(item._id)"
              :fullscreen="$vuetify.breakpoint.smAndDown"
            >
              <template v-slot:activator="{ on }">
                <a v-on="on" style="margin: auto;"><img style="max-width:200px; max-height:200px;" :src="item.entity.smallImagelUrl" ></a>
              </template>
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                  flat
                >
                  <v-toolbar-title>Просмотр изображения</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="closeImageForm(item._id)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text class="pa-3" style="text-align: center;">
                  <img :src="item.entity.mediumImageUrl" style="max-width: 100%;">
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeImageForm(item._id)">Закрыть</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>              
            <v-icon v-else size="200">{{ item.entity.iconName }}</v-icon>
          </div>
          <div>
            <v-progress-linear indeterminate v-if="item.loading"></v-progress-linear>
            <span v-else-if="Boolean(item.error)" style="color: red;">{{ item.error }}</span>
            <v-text-field
              v-else
              v-model="item.entity.name"
              label="Название"
              dense
              filled
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="item.entity" icon download :href="item.entity.originalUrl" target="_blank">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon @click="deleteUpload(item._id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import _ from 'lodash';
import { getTempId } from '../../models/common';

export default {
  name: 'files-table',

  props: {
    label: {
      type: String,
      default: 'Приложенные файлы'
    },
    value: {
      files: Array,
      loading: Boolean
    },
    singleFile: {
      type: Boolean,
      default: false
    },
    smIndex: {
      type: Number,
      default: 4
    }
  },

  data() {
    return {
      files: [],
      uploads: [],
      loading: 0,
    }
  },

  created() {
    this.uploads = this.value.map(item => ({
      _id: getTempId(),
      loading: false,
      fileName: '',
      error: false,
      entity: item,
      imageForm: false
    }));
  },

  methods: {
    changeFiles() {
      this.$emit('input', this.uploads.filter(x => x.entity).map(x => x.entity));
    },
    deleteUpload(id) {
      let ind = this.uploads.findIndex(x => x._id == id);
      this.uploads.splice(ind, 1);
      this.changeFiles();
    },
    closeImageForm(id) {
      let upload = this.uploads.find(x => x._id == id);
      upload.imageForm = false;
    }
  },

  watch: {
    files() {
      if (this.files.length > 0) {
        let newUploads = [];
        for (let file of this.files) {
          let upload = {
            _id: getTempId(),
            loading: true,
            fileName: file.name,
            error: false,
            entity: null,
            imageForm: false
          };
          this.loading++;
          this.$store.dispatch('loadFile', file)
          .then(res => {
            upload.entity = res.file;
            this.changeFiles();
          })
          .catch(err => {
            upload.error = err.message;
          })
          .finally(() => {
            upload.loading = false;
            this.loading--;
          });
          this.uploads.push(upload);
        }
        this.$nextTick(() => { this.files = [] });
      }
    },
    loading() {
      this.$emit('updateLoading', this.loading != 0);
    },
    isEnableUpload() {
      return this.uploads.length == 0;
    }
  }
}
</script>